<!--
 - Author : 003.wanghongling
 - Date   : 2019/5/31.
 - File   : peicLeader.地图摄像头
 -->

<template>
  <div class="dote-map">
    <!--<h2>{{deptName|nameFilter}}</h2>-->
    <h2>{{deptName}}</h2>
<!--    <canvas class="pointCanvas" ref="pointCanvas" width="1350" height="730"></canvas>-->
    <ul class="point" ref="point"
        :style="{background:floorList.length>0?'url('+imgUrl+floorBg+') no-repeat 0 0':defaultBgImg}">
      <!--电控盒列表-->
      <!--0101:留样冰箱  0102:消毒柜  0103:灭蝇灯  0201:温湿度感应器  0301:电 0401:水 0501:防鼠光栅  0502:防潮光栅  0503:挡鼠板门磁 0601:晨温一体机 1201:梦象-->
      <div v-for="(box, num) in boxList" :key="'info2-'+num">
        <!--温度感应器-->
        <div :class="['shidu',box.status!=='1'?'grayc':'']"
            :style="{left:box.xCoordinate + 'px',
            top:box.yCoordinate +'px',
            background: box.deviceFileId[0]?'url(' +imgUrl+box.deviceFileId[0] + ')':wdImg}"
            @click.stop="showMsg(box)"
            @mouseover="overEvent"
            @mouseout="outEvent"
            ref="box0"
            v-if="box.subType==='0201'">
          <span class="common-span">{{box.name||'未命名'}}</span>
          <!-- <h3>仓库区</h3> -->
          <p>温度:<span>{{box.tem}}℃</span></p>
          <p>湿度:<span>{{box.hum == 0 ? '--' : box.hum}}%</span></p>
        </div>
        <!--PM2.5感应器-->
        <div :class="['pm25',box.status!=='1'?'grayc':'']"
             :style="{left:box.xCoordinate + 'px',
            top:box.yCoordinate +'px',
            background: box.deviceFileId[0]?'url(' +imgUrl+box.deviceFileId[0] + ')':pm25Img}"
             @click.stop="showMsg(box)"
             @mouseover="overEvent"
             @mouseout="outEvent"
             ref="box0"
             v-if="box.subType === '0202'">
          <span class="common-span">{{box.name||'未命名'}}</span>
          <p>PM2.5:<span>{{box.pm2}}</span></p>
          <p>PM10:<span>{{box.pm10 == 0 ? '--' : box.pm10}}</span></p>
          <p>单位:ug/m³</p>
        </div>
        <!-- 臭氧感 -->
        <div :class="['ozone',box.status!=='1'?'grayc':'']"
             :style="{left:box.xCoordinate + 'px',
            top:box.yCoordinate +'px',
            background: box.deviceFileId[0]?'url(' +imgUrl+box.deviceFileId[0] + ')':ozoneImg}"
             @click.stop="showMsg(box)"
             @mouseover="overEvent"
             @mouseout="outEvent"
             ref="box0"
             v-if="box.subType === '0203'">
          <span class="common-span">{{box.name||'未命名'}}</span>
          <p>O₃:&nbsp;<span>{{box.ozone || 0}}</span></p>
          <p>单位:ppm</p>
        </div>
        <!--非以上几项等-->
        <div :class="['bx', box.status!=='1'?'grayc':'']"
            :style="{left:box.xCoordinate + 'px',
             top: box.yCoordinate+'px'}"
            v-if=" box.subType !== '0201' && box.subType !== '0202' && box.subType !=='0203'"
            ref="box"
            @mouseover="overEvent"
            @mouseout="outEvent"
            @click.stop="showMsg(box)">
          <span class="common-span">{{box.name||'未命名'}}</span>
          <img :src="box.deviceFileId[0]?imgUrl+box.deviceFileId[0]:defaultImg">
        </div>
        <!--留样冰箱-->
        <!--<div class="bx"
            :style="{left:box.xCoordinate + 'px',
             top: box.yCoordinate +'px'}"
            v-if="box.subType === '0101'"
            ref="box1"
            @mouseover="overEvent"
            @mouseout="outEvent"
            @click.stop="showMsg(box)">
          <span :class="['common-span', box.status!=='1'?'grayc':'']">{{box.name||'未命名'}}</span>
          <img :class="box.status!=='1'?'grayc':''" :src="box.deviceFileId[0]?imgUrl+box.deviceFileId[0]:defaultImg">
          &lt;!&ndash;<img v-if="box.status!=='1'" src="../../assets/images/shitang/bx_gray.gif">&ndash;&gt;
        </div>-->
      </div>
      <datePopover :title="currentPos.name"
          :width="datePopoverWidth"
          v-if="showTag && !excepOpen"
          :dateShow="true"
          :aqiMsg="currentPos"
          :subType="currentPos.subType"
          :deviceId="currentPos.deviceId"
          class="wave-bar"
          :style="{position:'absolute', left: boxPositionStyle.left+'px', top: boxPositionStyle.top, bottom:
               boxPositionStyle.bottom}"
          @selectTimeFn="changeTime"
          @closeEvent="closeEvent">
        <div :style="{display: openTag?'flex':'block',justifyContent: 'space-between'}">
          <!-- 电控盒、CO、CH4、水表-->
          <div :class="[openTag?'wave-class':'']" v-if="firstOpen">
            <div class="gl" v-if="currentPos.subType ==='0101' || currentPos.subType ==='0102' || currentPos.subType ==='0103'">
              <div class="gl-left">当前功率<span>{{currentPos.currPower}}w</span></div>
              <div class="gl-right">读取时间<span>{{currentPos.currDate}}</span></div>
            </div>
            <div class="gl" v-if="currentPos.subType=='0205' || currentPos.subType=='0206'">
              <div class="gl-left">当前浓度<span>{{currentPos.currPower}}{{currentPos.subType==='0205'?'%':'ppm'}}</span></div>
              <div class="gl-right">读取时间<span>{{currentPos.currDate}}</span></div>
            </div>
            <div class="gls" v-if="currentPos.subType==='0401'">
              <div class="gls-left">日耗水量<span>{{currentPos.todayWater ? currentPos.todayWater + 't' : '' ||'暂无'}}</span></div>
              <div class="gls-left">昨日水耗<span>{{currentPos.yesterdayWater ? currentPos.yesterdayWater + 't' : ''||'暂无'}}</span></div>
              <div class="gls-right">读取时间<span>{{currentPos.currDate||'暂无'}}</span></div>
            </div>
            <div v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.6)">
              <wave-bar :id="'riverInfo'+Math.random()" :waveList="waveList"></wave-bar>
            </div>
          </div>
          <!-- 温湿度 -->
          <div :class="[openTag?'wave-class':'']" v-if=" currentPos.subType==='0201' || currentPos.subType==='0202'">
            <div class="gl" v-if="currentPos.subType==='0201'">
              <div class="gl-left">当前温度<span>{{currentPos.currTemperature}}℃</span></div>
              <div class="gl-left">当前湿度<span>{{currentPos.currHumidity}}%</span></div>
              <div class="gl-right">读取时间<span>{{currentPos.currDate}}</span></div>
            </div>
            <div v-loading="loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.6)">
              <two-line :id="'line'+Math.random()" :twoLineList="humidityList"></two-line>
            </div>
          </div>
          <!-- 梦象 -->
          <div :class="[mxTag?'wave-class':'']" v-if="mxTag">
            <div class="gl">
              <div class="gl-left">电能<span>{{mxData.intervalElectricEnergy||'暂无'}}</span></div>
              <div class="gl-right">读取时间段<span>{{mxData.intervalDate||'暂无'}}</span></div>
            </div>
            <div v-loading="loading"
                 element-loading-text="加载中"
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0, 0, 0, 0.6)">
              <two-line :id="'line'+Math.random()" :twoLineList="mxList"></two-line>
            </div>
          </div>

          <!--留样冰箱开启记录-->
          <ul class="open-his-0602" v-if="currentPos.subType==='0602'">
            <li class="his-title">{{theTitle}}</li>
            <div style="min-height: 170px" v-show="HisOrExceptionList&&HisOrExceptionList.length>0">
              <li class="li" v-for="(item,index) in HisOrExceptionList" :key="index">
                <span class="li-left" v-if="!item.userName">{{item.cardNo}}</span>
                <span class="li-left">{{item.userName}}</span>
                <span class="li-right">{{item.openTime}}</span>
              </li>
            </div>
            <li class="no-his-data" v-show="HisOrExceptionList&&HisOrExceptionList.length===0">暂无{{theTitle}}</li>
            <el-pagination
                background
                small
                :page-size="parseInt(pageSize)"
                :current-page.sync="currentPage"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="totalCount">
            </el-pagination>
          </ul>

          <!--晨温一体机记录0601-->
          <div class="dote-scroll" v-if="currentPos.subType==='0601'">
            <el-form :inline="true" :model="formInline">
              <el-form-item label="状态">
                <el-select v-model="temparatureStatus" placeholder="请选择">
                  <el-option
                      v-for="item in formInline.state"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="姓名">
                <el-input v-model.trim="formInline.userName"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchTemp">查询</el-button>
              </el-form-item>
            </el-form>
            <div class="dote-scroll-title">
              <div>LDID：{{tempObj.uniqueCode}}</div>
              <div>状态：{{tempObj.status|filterDevState}}</div>
            </div>
            <el-table
                :data="tempObj.list"
                :row-class-name="tableRowClassName"
                style="width: 100%">
              <el-table-column
                  prop="signAvatar"
                  align="center"
                  label="抓拍照片">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="light" placement="right">
                    <div slot="content">
                      <el-image
                          :src="imgUrl+scope.row.signAvatar"
                          fit="cover"></el-image>
                    </div>
                    <el-image
                        style="width: 70px; height: 35px"
                        :src="imgUrl+scope.row.signAvatar"
                        fit="cover"></el-image>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                  prop="teperatureTime"
                  align="center"
                  label="测量时间">
              </el-table-column>
              <el-table-column
                  prop="userName"
                  align="center"
                  label="人员">
              </el-table-column>
              <el-table-column
                  prop="bodyTeperature"
                  align="center"
                  width="80px"
                  label="体温">
                <template slot-scope="scope">
                  {{scope.row.bodyTeperature}}℃
                </template>
              </el-table-column>
              <el-table-column
                  prop="teperatureStatus"
                  align="center"
                  width="80px"
                  label="状态">
                <template slot-scope="scope">
                  {{scope.row.teperatureStatus|filterTemState}}
                </template>
              </el-table-column>
            </el-table>
            <div class="tem-page">
              <el-pagination
                  background
                  :page-size="parseInt(pageSize1)"
                  :current-page.sync="currentPage"
                  @current-change="handleCurrentChange"
                  layout="prev, pager, next"
                  :total="tempObj.totalCount">
              </el-pagination>
            </div>
          </div>

          <ul class="open-his" v-if="currentPos.subType==='0301' || currentPos.subType==='0401'">
            <li class="his-title">{{theTitle}}</li>
            <div style="min-height: 170px" v-show="HisOrExceptionList&&HisOrExceptionList.length>0">
              <li class="li" v-for="(item, index) in HisOrExceptionList" :key="index">
                <span class="li-left">{{item.occurrenceTime}}</span>
                <span class="li-right">{{item.deviceName}}{{item.content}}</span>
              </li>
            </div>
            <li class="no-his-data" v-show="HisOrExceptionList&&HisOrExceptionList.length===0">暂无{{theTitle}}</li>
            <el-pagination
                background
                small
                :page-size="parseInt(pageSize)"
                :current-page.sync="currentPage"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="totalCount">
            </el-pagination>
          </ul>

        </div>
      </datePopover>
      <!--传感器弹窗-->
      <sensor
          :showTag="excepOpen"
          :boxPositionStyle="boxPositionStyle"
          :currentPos="currentPos"
          :HisOrExceptionList="HisOrExceptionList"
          :totalCount="totalCount"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @handleCurrentChange="handleCurrentChange"
          @changeTime="changeTime"
          @closeEvent="closeEvent">
      </sensor>
      <!--摄像头-->
      <li v-for="(item, index) in cameraList" :key="index" class="camera-pos" :style="{left:item.xCoordinate+'px',
           top:item.yCoordinate+'px'}">
        <span :class="['common-span common-span1', item.state !== '1' ? 'grayc' : '']">{{item.cameraName}}</span>
        <input type="radio" :id="item.cameraId" name="mapItem" @click="getCamera(item)" :disabled="item.state !== '1'">
        <label
            @click="getCamera(item)"
            @mouseover="overEvent"
            @mouseout="outEvent"
            :class="['c010101', item.state !== '1' ? 'grayc cusp' : '']"
            :for="item.id"
            :style="{background:'url(static/camera/' + item.type+item.position+item.color + '.png)'}">
        </label>
      </li>
    </ul>
    <div class="floor">
      <floor :floorList="floorList" num="8" @chooseEvent="chooseFloor"></floor>
    </div>
    <el-dialog
        width="850px"
        :title="cameraName"
        :visible.sync="isVideo"
        v-if="isVideo"
        :show-close="false"
        append-to-body>
      <my-video
          v-if="isVideo"
          @onClose="onClose"
          :md5Value="md5Value"
          :prefixUrl="prefixUrl"
          :hlsUrl="hlsUrl"
          :cameraId="cameraId"
          :tokenValue="tokenValue">
      </my-video>
    </el-dialog>
  </div>
</template>

<script>
  // import * as axios from 'axios'
  import dayjs from 'dayjs'

  export default {
    name: 'doteMap',
    data () {
      return {
        deptId: this.$route.query.deptId,
        deptName: this.$route.query.deptName,
        imgUrl: this.$store.getters.fileApi,
        defaultImg: require('../../assets/images/device.png'),
        defaultBgImg: require('../../assets/images/shitang/bg.png'),
        wdImg: require('../../assets/images/shitang/shidu.png'),
        pm25Img: require('../../assets/images/shitang/pm25.png'),
        ozoneImg: require('../../assets/images/shitang/ozone.png'),
        waveTag: false,
        openTag: false,
        mxTag: false, // 梦象设备显示
        boxList: [], // 获取的接口的电控盒列表
        tempObj: {},
        pageSize: 8,
        pageSize1: 5,
        currentPage: 1,
        totalCount: 0,
        temparatureStatus: '',
        formInline: {
          userName: '',
          state: [
            {
              value: '',
              label: '全部'
            },
            {
              value: '0',
              label: '异常'
            },
            {
              value: '1',
              label: '正常'
            }
          ]
        },
        theTitle: '开启记录',
        HisOrExceptionList: [],
        loading: false,
        mapLoading: false,
        waveList: {
          // 正常电控设备数据
          margin: '0 auto 10px',
          height: '200px',
          gridTop: '22%',
          xSplitColor: '#014778',
          ySplitColor: '#014778',
          axisLabel: {
            fontSize: 12
          },
          yAxisName: '单位：W',
          dw: 'w',
          xData: [],
          data: []
        },
        humidityList: {
          // 温湿度数据
          margin: '0px auto 0',
          height: '190px',
          gridTop: '22%',
          xSplitColor: '#014778',
          ySplitColor: '#014778',
          axisLabel: {
            fontSize: 12
          },
          xName: ['温度', '湿度'],
          yName: ['温度：℃', '湿度：%'],
          dw1: '℃',
          dw2: '%',
          markLineName: '温度检测值',
          markLineValue: 0,
          markLineOpacity: 0,
          markLineShow: false,
          xData: [],
          data1: [],
          data2: []
        },
        mxList:{
          // 温湿度数据
          margin: '0px auto 0',
          height: '190px',
          gridTop: '22%',
          xSplitColor: '#014778',
          ySplitColor: '#014778',
          axisLabel: {
            fontSize: 12
          },
          xName: ['功率', '电能'],
          yName: ['功率：W', '电能：kWh'],
          dw1: 'W',
          dw2: 'kWh',
          markLineName: '温度检测值',
          markLineValue: 0,
          markLineOpacity: 0,
          markLineShow: false,
          xData: [],
          data1: [],
          data2: []
        },
        airQualityList: {
          // 温湿度数据
          margin: '0px auto 0',
          height: '190px',
          gridTop: '22%',
          xSplitColor: '#014778',
          ySplitColor: '#014778',
          axisLabel: {
            fontSize: 12
          },
          xName: ['浓度'],
          yName: ['温度：ug/m³'],
          dw1: 'ug/m³',
          markLineName: '浓度',
          markLineValue: 0,
          markLineOpacity: 0,
          markLineShow: false,
          xData: [],
          data1: [],
          data2: []
        },
        currentPos: {},
        showTag: false,
        showSensor: false,
        defaultDeviceList: [],
        defalutAirQualityList: [],
        defaultOzoneList: [],
        cameraList: [],
        boxPositionStyle: {
          left: 0,
          top: 0
        }, // 设备弹出层位置
        tmpId: null,
        floorList: [],
        allDeviceObj: {},
        floorBg: '',
        halfWidth: null,
        halfHeight: null,
        videoTitle: '查看视频',
        isVideo: false,
        videoLoading: false,
        hlsUrl: null,
        tokenValue: null,
        prefixUrl: null,
        md5Value: null,
        cameraData: {},
        cameraName: '',
        cameraId: '',
        // 电控盒、甲烷、CO、水表
        firstDeviceArr: ['0101','0102','0103','0203','0205','0206','0401'],
        // false：关闭 true：打开
        firstOpen: false,
        // 光栅、烟雾、水浸
        exceptionDeviceArr: ['0501','0502','0503','1002','1003'],
        // 异常类型设备开启标识，false：关闭 true：打开
        excepOpen: false,
        videoWidth: '800px',
        mxData: {
          intervalTime: '',
          intervalElectricEnergy: ''
        }, //梦象数据
        datePopoverWidth: '400px'
      }
    },
    methods: {
      /**
       * @Description:设置设备弹出框的大小
       * @author wanghongling
       * @createDate 2020/4/28
       */
      setPopoverWidth(subType)
      {
        switch (subType)
        {
          case '0101':
            this.datePopoverWidth = '500px'
            break
          case '0102':
            this.datePopoverWidth = '500px'
            break
          case '0103':
            this.datePopoverWidth = '500px'
            break
          case '0201':
            this.datePopoverWidth = '500px'
            break
          case '0202':
            this.datePopoverWidth = '500px'
            break
          case '0203':
            this.datePopoverWidth = '500px'
            break
          case '0205':
            this.datePopoverWidth = '500px'
            break
          case '0206':
            this.datePopoverWidth = '500px'
            break
          case '0301':
            this.datePopoverWidth = '760px'
            break
          case '0401':
            this.datePopoverWidth = '760px'
            break
          case '0501':
            this.datePopoverWidth = '500px'
            break
          case '0502':
            this.datePopoverWidth = '500px'
            break
          case '0503':
            this.datePopoverWidth = '500px'
            break
          case '0601':
            this.datePopoverWidth = '720px'
            break
          case '0602':
            this.datePopoverWidth = '760px'
            break
          case '1002':
            this.datePopoverWidth = '500px'
            break
          case '1003':
            this.datePopoverWidth = '500px'
            break
          case '1201':
            this.datePopoverWidth = '500px'
            break
          default:
            this.datePopoverWidth = '400px'
        }
      },
      /**
       * @Description:返回体温异常行
       * @author wanghongling
       * @createDate 2020/4/28
       */
      tableRowClassName ({row}) {
        if (row.teperatureStatus === 0) {
          return 'warning-row'
        } else {
          return ''
        }
      },
      /**
       * @Description:楼层切换调用事件
       * @author wanghongling
       * @createDate 2019/12/10
       */
      chooseFloor (item) {
        console.log('chooseFloor///////~~~', item)
        this.getSFloorDList(item.xyList)
        this.cameraList = item.cameraList
        this.floorBg = item.floorFileId[0]
        this.showTag = false
        this.tmpId = null
        // this.getExceptionContrailGet(item.floorId)
      },
      /**
       * @Description:显示选中楼层的设备列表
       * @author wanghongling
       * @createDate 2019/12/10
       */
      getSFloorDList (list) {
        if (!list) return
        this.boxList = list
        let no0 = 0
        let no = 0
        let no1 = 0
        list.map((val, index) => {
          switch (val.subType) {
            case '0101':
              this.$set(list[index], 'no1', no1)
              no1++
              break
            case '0201':
            case '0204':
              this.$set(list[index], 'no0', no0)
              no0++
              break
            default:
              this.$set(list[index], 'no', no)
              no++
              break
          }
        })
        setTimeout(() => {
          if (this.$refs.box0 !== undefined) {
            for (let i = 0; i < this.$refs.box0.length; i++) {
              list.map((v, num) => {
                if (list[num].no === i) {
                  this.$set(list[num], 'width', this.$refs.box0[i].offsetWidth)
                  this.$set(list[num], 'height', this.$refs.box0[i].offsetHeight)
                }
              })
            }
          }
          if (this.$refs.box !== undefined) {
            for (let i = 0; i < this.$refs.box.length; i++) {
              list.map((v, num) => {
                if (list[num].no === i) {
                  this.$set(list[num], 'width', this.$refs.box[i].offsetWidth)
                  this.$set(list[num], 'height', this.$refs.box[i].offsetHeight)
                }
              })
            }
          }
          if (this.$refs.box1 !== undefined) {
            for (let i = 0; i < this.$refs.box1.length; i++) {
              list.map((v, num) => {
                if (list[num].no1 === i) {
                  this.$set(list[num], 'width', this.$refs.box1[i].offsetWidth)
                  this.$set(list[num], 'height', this.$refs.box1[i].offsetHeight)
                }
              })
            }
          }
        }, 500)
      },
      /**
       * @Description:微生物运动轨迹
       * @author zhuangsw
       * @createDate 2021/09/09
       */
      getExceptionContrailGet (floorId) {
        this.$request.exceptionContrailGet({id: floorId}).then(res => {
          console.log('微生物运动轨迹', res)
          let ctx = this.$refs.pointCanvas.getContext('2d')
          ctx.strokeStyle = 'red'
          ctx.clearRect(0,0, 1350, 730)
          if (res.coordinateList.length > 0) {
            ctx.beginPath()
            ctx.lineWidth = 1
            // ctx.font="12px Georgia"
            // ctx.strokeText("生物轨迹",res.coordinateList[2].xCoordinate, res.coordinateList[2].yCoordinate + 50)
            ctx.lineWidth = 3
            ctx.moveTo(res.coordinateList[2].xCoordinate + 10, res.coordinateList[2].yCoordinate + 30)
            ctx.lineTo(res.coordinateList[1].xCoordinate + 10, res.coordinateList[1].yCoordinate + 25)
            // ctx.lineTo(res.coordinateList[1].xCoordinate + 10, res.coordinateList[1].yCoordinate + 30)
            ctx.lineTo(res.coordinateList[5].xCoordinate + 10, res.coordinateList[5].yCoordinate + 30)
            ctx.lineTo(res.coordinateList[0].xCoordinate + 10, res.coordinateList[0].yCoordinate + 30)
            ctx.lineTo(res.coordinateList[4].xCoordinate + 10, res.coordinateList[4].yCoordinate + 30)
            ctx.lineTo(res.coordinateList[3].xCoordinate + 10, res.coordinateList[3].yCoordinate + 30)
            // ctx.closePath()
            ctx.stroke()
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:根据食堂获取基础设备和摄像头坐标（食堂预览）
       * @author wanghongling
       * @createDate 2019/12/10
       */
      getAllDeviceObj () {
        this.$request.deviceXyListGet({departmentId: this.deptId}).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            console.log('据食堂获取基础设备和摄像头坐标', res)
            this.allDeviceObj = res
            this.floorList = res.floorList
            if (res.floorList.length === 0) return
            this.floorBg = res.floorList[0].floorFileId[0]
            this.getSFloorDList(res.floorList[0].xyList)
            this.cameraList = res.floorList[0].cameraList
            this.getDefaultDeviceList(res.floorList)
            // this.getExceptionContrailGet(this.floorList[0].floorId)
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:websocket监听推送摄像头状态
       * @author wanghongling
       * @createDate 2019/12/12
       */
      getCameraState () {
        window.getCameraState = e => {
          this.floorList.map(val => {
            val.cameraList.map(v => {
              if (v.cameraIp === e.content.cameraIp) {
                v.state = e.content.state
              }
            })
          })
        }
      },
      /**
       * 温湿度设备初始化列表
       * @author wanghongling
       * @createDate 2019-07-25
       * @returns {string}
       */
      getDefaultDeviceList (floorList) {
        return this.$request.deviceDefaultList({departmentId: this.deptId}).then(res => {
          console.log('温湿度设备初始化列表', res)
          // 温湿度设备的初始值数据
          this.defaultDeviceList = res.temperatureList
          // 空气质量的初始值数据
          this.defalutAirQualityList = res.airQualityList
          // 臭氧数据
          this.defaultOzoneList = res.ozoneList
          // 臭氧数据
          setTimeout(() => {
            this.defaultOzoneList && this.defaultOzoneList.map(v => {
              floorList.map(floor => {
                let a = floor.xyList
                a.map(val => {
                  if (v.deviceId === val.deviceId) {
                    this.$set(val, 'ozone', v.ozone)
                  }
                })
              })
            })
          }, 0)
          // 循环设备添加设备数据
          setTimeout(() => {
            this.defalutAirQualityList && this.defalutAirQualityList.map(v => {
              floorList.map(floor => {
                let a = floor.xyList
                a.map(val => {
                  if (v.deviceId === val.deviceId) {
                    this.$set(val, 'pm2', v.pm2)
                    this.$set(val, 'pm10', v.pm10)
                  }
                })
              })
            })
          }, 0)
          setTimeout(() => {
            this.defaultDeviceList && this.defaultDeviceList.map(v => {
              floorList.map(floor => {
                let a = floor.xyList
                a.map(val => {
                  if (v.deviceId === val.deviceId) {
                    this.$set(val, 'hum', v.hum)
                    this.$set(val, 'tem', v.tem)
                  }
                })
              })
            })
          }, 0)
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 光标移动事件
       * @author wanghongling
       * @createTime 2019/07/25
       */
      overEvent (e) {
        e.target.parentElement.style.zIndex = 9
      },
      /**
       * 光标离开事件
       * @author wanghongling
       * @createTime 2019/07/25
       */
      outEvent (e) {
        var zIndex = (e.target.parentNode.className === 'shidu') ? 2 : 3
        e.target.parentElement.style.zIndex = zIndex
      },
      /**
       * 切换时间查看功率
       * 1001，1002，1003 传感器
       * 0101:留样冰箱  0102:消毒柜  0103:灭蝇灯  0201:温湿度感应器  0301:电
       * 0401:水 0501:防鼠光栅  0502:防潮光栅  0503:挡鼠板门磁  0601:晨温一体机
       * @author wanghongling
       * @areateTime 2019/06/25
       */
      changeTime (val) {
        this.time = val
        console.log('this.currentPos', this.currentPos)
        switch (this.currentPos.subType) {
          case '0501':
            this.getExceptionDeviceList(this.deptId, this.currentPos.deviceId, this.currentPage, this.pageSize, this.currentPos.date)
            break
          case '0502':
            this.getExceptionDeviceList(this.deptId, this.currentPos.deviceId, this.currentPage, this.pageSize, this.currentPos.date)
            break
          case '0503':
            this.getExceptionDeviceList(this.deptId, this.currentPos.deviceId, this.currentPage, this.pageSize, this.currentPos.date)
            break
          case '0101':
          case '0103':
            this.getVoltage24(this.currentPos.deviceId, val)
            if(this.currentPos.subType === '0101') this.getBxHisList(this.currentPos.deviceId, val)
            break
          case '0201':
          case '0204':
            this.getHumidity24(this.currentPos.deviceId, val)
            break
          case '0202':
            this.getAirQuality24(this.currentPos.deviceId, val)
            break
          case '0203':
            this.getOzone(this.currentPos.deviceId, val)
            break
          case '0205':
            this.waveTag = true
            this.$nextTick(() => {
              this.getMethane24(this.currentPos.deviceId, val)
            })
            break
          case '0206':
            this.waveTag = true
            this.$nextTick(() => {
              this.getCarbonMonoxide24(this.currentPos.deviceId, val)
            })
            break
          case '0301':
            this.currentPage = 1
            this.getDeviceElectric24(this.currentPos.deviceId, val)
            this.getExceptionDeviceList(this.deptId, this.currentPos.deviceId, this.currentPage, this.pageSize, val)
            break
          case '0401':
            this.currentPage = 1
            this.getWater24(this.currentPos.deviceId, val)
            this.getExceptionDeviceList(this.deptId, this.currentPos.deviceId, this.currentPage, this.pageSize, val)
            break
          case '0601':
            this.currentPage = 1
            this.getDeviceTemperature(this.currentPos.deviceId, val, this.currentPage, this.pageSize1, this.temparatureStatus, this.formInline.userName)
            break
          case '0602':
            this.currentPage = 1
            this.getBxHisList(this.currentPos.deviceId, val)
            break
          case '1001':
            this.getExceptionDeviceList(this.deptId, this.currentPos.deviceId, this.currentPage, this.pageSize, this.currentPos.date)
            break
          case '1002':
            this.getExceptionDeviceList(this.deptId, this.currentPos.deviceId, this.currentPage, this.pageSize, this.currentPos.date)
            break
          case '1003':
            this.getExceptionDeviceList(this.deptId, this.currentPos.deviceId, this.currentPage, this.pageSize, this.currentPos.date)
            break
          default:
            this.waveTag = true
            this.$nextTick(() => {
              this.getVoltage24(this.currentPos.deviceId, val)
            })
            break
        }
      },
      /**
       * 展示温湿度、冰箱、消毒柜信息
       * 1001，1002，1003 传感器
       * 0101:留样冰箱  0102:消毒柜  0103:灭蝇灯  0201:温湿度感应器  0301:电
       * 0401:水 0501:防鼠光栅  0502:防潮光栅  0503:挡鼠板门磁 0601:晨温一体机
       * @author wanghongling
       * @param cur
       * @returns {string}
       */
      showMsg (cur) {
        if (this.tmpId === cur.deviceId) return
        this.$set(cur, 'date', dayjs().format('YYYY-MM-DD'))
        this.currentPos = cur
        this.time = cur.date
        this.currentPage = 1
        this.showTag = true
        this.openTag = false
        this.showSensor = false
        console.log('cur, currentPos', cur, this.currentPos)
        this.setPopoverWidth(cur.subType)

        this.firstOpen = false;
        if(this.firstDeviceArr.includes(cur.subType))
        {
          this.firstOpen = true;
          console.log('cur, firstOpen', cur, this.firstOpen)
        }

        this.excepOpen = false;
        if(this.exceptionDeviceArr.includes(cur.subType))
        {
          this.excepOpen = true;
          this.showTag = false
        }

        switch (cur.subType) {
          case '0101':
            this.$nextTick(() => {
              this.getVoltage24(cur.deviceId, cur.date)
            })
            break
          case '0102':
            this.$nextTick(() => {
              this.getVoltage24(cur.deviceId, cur.date)
            })
            break
          case '0103':
            this.waveTag = true
            this.theTitle = '开启记录'
            this.$nextTick(() => {
              this.getVoltage24(cur.deviceId, cur.date)
            })
            break
          case '0201':
            this.waveTag = false
            this.$nextTick(() => {
              this.getHumidity24(cur.deviceId, cur.date)
            })
            break
          case '0202':
            this.waveTag = false
            this.$nextTick(() => {
              this.getAirQuality24(cur.deviceId, cur.date)
            })
            break
          case '0203':
            this.waveTag = true
            this.$nextTick(() => {
              this.getOzone(cur.deviceId, cur.date)
            })
            break
          case '0205':
            this.waveTag = true
            this.$nextTick(() => {
              this.getMethane24(cur.deviceId, cur.date)
            })
            break
          case '0206':
            this.waveTag = true
            this.$nextTick(() => {
              this.getCarbonMonoxide24(cur.deviceId, cur.date)
            })
            break
          case '0301':
            this.waveTag = true
            this.openTag = true
            this.theTitle = '异常告警'
            this.getDeviceElectric24(cur.deviceId, cur.date)
            this.getExceptionDeviceList(this.deptId, cur.deviceId, this.currentPage, this.pageSize, cur.date)
            break
          case '0401':
            this.waveTag = true
            this.openTag = true
            this.theTitle = '异常告警'
            this.$nextTick(() => {
              this.getWater24(cur.deviceId, cur.date)
              this.getExceptionDeviceList(this.deptId, cur.deviceId, this.currentPage, this.pageSize, cur.date)
            })
            break
          case '0501':
            this.showSensor = true
            this.showTag = false
            this.$nextTick(() => {
              this.getExceptionDeviceList(this.deptId, cur.deviceId, 1, this.pageSize, cur.date)
            })
            break
          case '0502':
            this.showSensor = true
            this.showTag = false
            this.$nextTick(() => {
              this.getExceptionDeviceList(this.deptId, cur.deviceId, 1, this.pageSize, cur.date)
            })
            break
          case '0503':
            this.showSensor = true
            this.showTag = false
            this.$nextTick(() => {
              this.getExceptionDeviceList(this.deptId, cur.deviceId, 1, this.pageSize, cur.date)
            })
            break
          case '0601':
            this.temparatureStatus = ''
            this.$nextTick(() => {
              this.getDeviceTemperature(this.currentPos.deviceId, cur.date, this.currentPage, this.pageSize1, this.temparatureStatus, this.formInline.userName)
            })
            break
          // 留样冰箱
          case '0602':
            this.theTitle = '开启记录'
            this.$nextTick(() => {
                this.openTag = true
                this.getBxHisList(cur.deviceId, cur.date)
            })
            break
          case '1001':
            break
          case '1002':
            break
          case '1003':
            break
          // 梦象
          case '1201':
            this.mxTag = true
            this.$nextTick(() => {
              this.getMx(cur.deviceId, cur.date)
            })
            break
          default:
            this.waveTag = true
            this.$nextTick(() => {
              this.getVoltage24(cur.deviceId, cur.date)
            })
            break
        }
        this.tmpId = cur.deviceId
      },
      /**
       * @Description:根据条件查找晨检列表
       * @author wanghongling
       * @createDate 2020/5/13
       */
      searchTemp () {
        this.currentPage = 1
        this.getDeviceTemperature(this.currentPos.deviceId, this.time, this.currentPage, this.pageSize1, this.temparatureStatus, this.formInline.userName)
      },
      /**
       * 获取24小时甲烷变化
       * @author wanghongling
       * @createDate 2019-07-25
       * @param deviceId
       * @param monltorTime
       */
      getMethane24 (deviceId, monltorTime) {
        this.loading = true
        this.$request.deviceMethane24Get({deviceId, monltorTime}).then(res => {
          console.log('获取24小时甲烷变化', res)
          this.waveList.xData = res.dataKey
          this.waveList.data = res.concentrationeValue
          this.waveList.yAxisName = '单位：%'
          this.waveList.dw = '%'
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'currPower', res.currConcentration)
          this.$set(this.currentPos, 'currTotalEnergyConsumption', res.currTotalEnergyConsumption)
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })
      },
      /**
       * 获取梦象设备（按分钟）
       * @author wuzp
       * @createDate 2019-07-25
       * @param deviceId
       * @param monltorTime
       */
      getMx (deviceId, monltorTime) {
        this.loading = true
        let currentDate = new Date()
        let hour = currentDate.getHours()
        let lastHour = hour-2
        let minute = currentDate.getMinutes()
        let intervalMinuter = 10
        let params = {
          'beginTime': monltorTime+" "+this.getPaddingZero(lastHour)+":"+this.getPaddingZero(minute)+":00",
          'endTime': monltorTime+" "+this.getPaddingZero(hour)+":"+this.getPaddingZero(minute)+":59",
          deviceId,
          intervalMinuter,
        }

        this.$request.mxPowerMinuterAnalyse(params).then(res => {
          console.log('获取梦象功率变化', res)
          if(res == null){
            return
          }
          this.mxList.xData = res.timeList
          this.mxList.data1 = res.valList

          this.$request.mxEnergyMinuterAnalyse(params).then(energy => {
            console.log('获取梦象电能变化', energy)
            if(energy == null){
              return
            }
            this.mxList.data2 = energy.valList
          }).catch(ex => {
            this.$superMessage('提示', ex.msg)
          }).finally(() => {
            this.loading = false
          })
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })

        this.getMxData(deviceId , monltorTime , intervalMinuter)
      },
      /**
       * 获取梦象设备-数据分析（按分钟）
       * @author wuzp
       * @createDate 2019-07-25
       * @param deviceId
       * @param monltorTime
       */
      getMxData(deviceId, monltorTime, intervalMinuter){
        this.loading = true
        let currentDate = new Date()
        let hour = currentDate.getHours()
        let minute = currentDate.getMinutes()
        let lastCurrent = new Date()
        lastCurrent.setMinutes(lastCurrent.getMinutes()-intervalMinuter)
        let params = {
          'beginTime': lastCurrent.getFullYear()+"-"+this.getPaddingZero(lastCurrent.getMonth()+1)+"-"+this.getPaddingZero(lastCurrent.getDate())+" "+this.getPaddingZero(lastCurrent.getHours())+":"+ this.getPaddingZero(lastCurrent.getMinutes())+":00",
          'endTime': monltorTime+" "+this.getPaddingZero(hour)+":"+this.getPaddingZero(minute)+":59",
          deviceId
        }

        this.$request.mxIntervalDataAnalyse(params).then(res => {
          console.log('获取梦象数据变化', res)
          if(res == null){
            return
          }
          this.mxData = res
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })
      },
      /**
       * 填充0
       * @author wuzp
       */
      getPaddingZero(val){
         return val<10 ? "0"+val : val
      },
      /**
       * 获取24小时一氧化碳变化
       * @author wanghongling
       * @createDate 2019-07-25
       * @param deviceId
       * @param monltorTime
       */
      getCarbonMonoxide24 (deviceId, monltorTime) {
        this.loading = true
        this.$request.deviceCarbonMonoxide24Get({deviceId, monltorTime}).then(res => {
          console.log('获取24小时一氧化碳变化', res)
          this.waveList.xData = res.dataKey
          this.waveList.data = res.concentrationeValue
          this.waveList.yAxisName = '单位：ppm'
          this.waveList.dw = 'ppm'
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'currPower', res.currConcentration)
          this.$set(this.currentPos, 'currTotalEnergyConsumption', res.currTotalEnergyConsumption)
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })
      },
      /**
       * @description: 臭氧
       * @author: linwen linwen@fjxhx.com
       * @createDate: 2020-10-14 18:19
       * @param: 臭氧
       * @return:
       */
      getOzone(deviceId, monltorTime) {
        this.loading = true
        this.$request.deviceOzone24Get({deviceId, monltorTime}).then(res => {
          console.log('获取24小时臭氧变化', res)
          this.waveList.xData = res.dataKey
          this.waveList.data = res.ozoneConcentrationValue
          this.waveList.yAxisName = '单位：ppm'
          this.waveList.dw = 'ppm'
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'currPower', res.currConcentration)
          this.$set(this.currentPos, 'currTotalEnergyConsumption', res.currTotalEnergyConsumption)
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })
      },
      /**
       * 24小时功率变化
       * @author wanghongling
       * @areateTime 2019/06/25
       */
      getVoltage24 (deviceId, monltorTime) {
        console.log('24小时功率变化', deviceId, monltorTime)
        this.loading = true
        this.$request.deviceVoltage24Get({deviceId, monltorTime}).then(res => {
          console.log('24小时功率变化', res)
          this.waveList.xData = res.dataKey
          this.waveList.data = res.dataValue
          this.waveList.yAxisName = '单位：W'
          this.waveList.dw = 'W'
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'currPower', res.currPower)
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })
      },
      /**
       * 获取24小时温湿度变化
       * @author wanghongling
       * @createDate 2019-07-25
       * @param deviceId
       * @param monltorTime
       */
      getHumidity24 (deviceId, monltorTime) {
        this.loading = true
        this.$request.deviceTemperatureHumidity24Get({deviceId, monltorTime}).then(res => {
          console.log('获取24小时温湿度变化', res)
          this.humidityList.xData = res.dataKey
          this.humidityList.data1 = res.temperatureValue
          this.humidityList.data2 = res.humidityValue
          this.humidityList.xName = ['温度', '湿度']
          this.humidityList.yName = ['温度：℃', '湿度：%']
          this.humidityList.dw1 = '℃'
          this.humidityList.dw2 = '%'
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'currHumidity', res.currHumidity)
          this.$set(this.currentPos, 'currTemperature', res.currTemperature)
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })
      },
      /**
       * @description: 获取24小时空气质量变化
       * @author: linwen linwen@fjxhx.com
       * @createDate: 2020-10-13 17:41
       * @param: deviceId 设备ID
       * @param: monltorTime 监测日期
       * @return:
      */
      getAirQuality24(deviceId, monltorTime) {
        this.loading = true
        this.$request.deviceAirQuality24Get({deviceId, monltorTime}).then(res => {
          console.log('获取24小时空气质量变化', res)
          this.humidityList.xData = res.dataKey
          this.humidityList.data1 = res.pm2Value
          this.humidityList.data2 = res.pm10Value
          this.humidityList.xName = ['PM2.5', 'PM10']
          this.humidityList.yName = ['PM2.5：μg/m³', 'PM10：μg/m³']
          this.humidityList.dw1 = 'μg/m³'
          this.humidityList.dw2 = 'μg/m³'
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'currHumidity', res.currHumidity)
          this.$set(this.currentPos, 'currTemperature', res.currTemperature)
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })
      },
      /**
       * 获取24小时用水变化
       * @author wanghongling
       * @createDate 2019-07-25
       * @param deviceId
       * @param monltorTime
       */
      getWater24 (deviceId, monltorTime) {
        this.loading = true
        this.$request.deviceWater24Get({deviceId, monltorTime}).then(res => {
          console.log('获取24小时用水变化', res)
          this.waveList.xData = res.dateKey
          this.waveList.data = res.dateValue
          this.waveList.yAxisName = '单位：t'
          this.waveList.dw = 't'
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'todayWater', res.todayWater)
          this.$set(this.currentPos, 'yesterdayWater', res.yesterdayWater)
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })
      },
      /**
       * 获取24小时用电变化
       * @author wanghongling
       * @createDate 2019-07-25
       * @param deviceId
       * @param monltorTime
       */
      async getDeviceElectric24 (deviceId, monltorTime) {
        this.loading = true
        this.$request.deviceElectric24Get({deviceId, monltorTime}).then(res => {
          console.log('获取24小时用电变化', res)
          this.waveList.xData = res.dataKey
          this.waveList.data = res.powerValue
          this.waveList.yAxisName = '单位：w'
          this.waveList.dw = 'w'
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'currPower', res.currPower)
          this.$set(this.currentPos, 'currTotalEnergyConsumption', res.currTotalEnergyConsumption)
        }).catch(e => {
          this.$superMessage('提示', e.msg)
        }).finally(() => {
          this.loading = false
        })
      },
      /**
       * 获取留样冰箱开启记录列表
       * @author wanghongling
       * @createDate 2019-05-15
       */
      getBxHisList (deviceId, time) {
        let params = {
          departmentId: this.deptId,
          deviceId: deviceId,
          page: this.currentPage,
          pageSize: this.pageSize,
          time: time
        }
        this.$request.fridgeRecordListGet(params).then(res => {
          console.log('获取留样冰箱开启记录列表', res, deviceId)
          this.HisOrExceptionList = []
          this.totalCount = res.totalCount
          this.HisOrExceptionList = res.resultList
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 根据设备ID获取设备异常记录
       * @author wanghongling
       * @areateTime 2019/08/01
       */
      getExceptionDeviceList (departmentId, deviceId, page, pageSize, time) {
        this.HisOrExceptionList = []
          this.$request.exceptionDeviceListGet({departmentId, deviceId, page, pageSize, time}).then(res => {
          console.log('根据设备ID获取设备异常记录', res)
          this.totalCount = res.totalCount
          this.HisOrExceptionList = res.resultList
        }).catch(e => {
          console.error(e)
        // this.$superMessage('提示', e)
        })
      },
      /**
       * @Description:点击晨检设备显示体温检测记录
       * @author wanghongling
       * @createDate 2020/4/28
       */
      getDeviceTemperature (deviceId, occurDate, page, pageSize, temparatureStatus, userName) {
        this.$request.pcHealthDeptDeviceTemperature({
          deviceId,
          occurDate,
          page,
          pageSize,
          temparatureStatus,
          userName
        }).then(res => {
          console.log('res', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.tempObj = res
          }
        }).catch(e => {
          console.log(e)
        // this.$superMessage('提示', e)
        })
      },
      /**
       * 对接qt端摄像头信息
       * @author chend
       * @createTime 2019/07/17
       */
      getCamera (cur) {
        console.log('cur', cur)
        this.cameraName = cur.cameraName
        // if (cur.state !== '1') return
        this.videoLoading = true
        this.isVideo = true
        this.hlsUrl = ''
        this.$request.cameraStreamGet({cameraId: cur.cameraId}).then(res => {
          console.log('获取摄像头信息流', res)
          this.hlsUrl = res.streamUrl
          this.cameraId = cur.cameraId
          console.error(this.cameraData, 'this.cameraData')
          this.videoLoading = false
        }).catch(e => {
          console.error(e)
        })
      },
      onClose() {
        this.isVideo = false
        console.log('视频页面关闭:', this.isVideo)
      },
      /**
       * 获取websocket推送的温湿度信息和设备状态
       * @author wanghongling
       * @createTime 2019/06/24
       */
      getWsd () {
        window.getTempHum = e => {
          this.boxList.map(v => {
            if (e.content.departmentId === this.deptId) {
              if (e.content.deviceId === v.deviceId && v.subType === '0201') {
                this.$set(v, 'hum', e.content.hum)
                this.$set(v, 'tem', e.content.tem)
              }
            }
          })
        }
        window.getDeviceStatus = e => {
          // console.error(e, '推送的设备状态', this.boxList)
          this.boxList.map(v => {
            if (e.content.departmentId === this.deptId) {
              if (e.content.deviceId === v.deviceId && v.subType === e.content.type) {
                v.status = e.content.status
              }
            }
          })
        }
        // websocket推送空气质量的数据
        window.getAirQuality = e => {
          this.boxList.map(v => {
            if (e.content.departmentId === this.deptId) {
              if (e.content.deviceId === v.deviceId && v.subType === '0202') {
                this.$set(v, 'pm2', e.content.pm2)
                this.$set(v, 'pm10', e.content.pm10)
              }
            }
          })
        }
        // websocket推送空气质量的数据
        window.getOzone = e => {
          this.boxList.map(v => {
            if (e.content.departmentId === this.deptId) {
              if (e.content.deviceId === v.deviceId && v.subType === '0203') {
                this.$set(v, 'ozone', e.content.ozone)
              }
            }
          })
        }
      },
      /**
       * 页码改变-冰箱开启记录翻页
       * @author wanghongling
       * @createDate 2019-05-15
       * @param {Object} e
       */
      handleCurrentChange (e) {
        this.currentPage = e
        if (this.currentPos.subType === '0101') {
          this.getBxHisList(this.currentPos.deviceId, this.time)
        } else if (this.currentPos.subType === '0601') {
          this.getDeviceTemperature(this.currentPos.deviceId, this.time, this.currentPage, this.pageSize1, this.temparatureStatus, this.formInline.userName)
        } else {
          this.getExceptionDeviceList(this.deptId, this.currentPos.deviceId, this.currentPage, this.pageSize, this.time)
        }
      },
      /**
       * 关闭设备资源异常统计弹窗
       * @author wanghongling
       * @createDate 2019-05-15
       */
      closeEvent (item) {
        if (item === '01') {
          this.showSensor = false
          this.excepOpen = false
        } else {
          this.showTag = false
          this.mxTag = false
        }
        this.tmpId = null
      }
    },
    mounted () {
      this.halfWidth = this.$refs.point.clientWidth / 2
      this.halfHeight = this.$refs.point.clientHeight / 2
      this.getWsd()
      this.getCameraState()
      this.getAllDeviceObj()
    },
    computed: {},
    watch: {
      /**
       * 监听设备弹出层显示的位置
       * @author wanghongling
       * @createTime 2019-07-19
       */
      currentPos (cur) {
        let xTmp = (cur.subType === '0201' || cur.subType === '0202' || cur.subType === '0203') ? 20 : 10
        let xTmp1 = (cur.subType === '0201' || cur.subType === '0202' || cur.subType === '0203') ? 90 : 25
        let tmp
        if (this.openTag) {
          tmp = 780
        } else {
          tmp = (cur.subType !== '0601') ? 520 : 740
        }
        let val1 = cur.yCoordinate - 10
        let val2 = (cur.subType === '0601') ? cur.yCoordinate - 350 : cur.yCoordinate - 200
        let finalVal = cur.yCoordinate > this.halfHeight ? val2 : val1
        let finalTop = cur.yCoordinate > this.halfHeight ? 'inherit' : `${finalVal}px`
        let boxHeight = (cur.subType === '0201' || cur.subType === '0202' || cur.subType === '0203' || cur.subType === '0204') ? (cur.yCoordinate + 90) : (cur.yCoordinate + cur.height)
        let finalBottom = cur.yCoordinate > this.halfHeight ? (this.halfHeight * 2 - boxHeight) + 'px' : 'inherit'
        if (cur.xCoordinate > (this.halfWidth - 50)) {
          this.boxPositionStyle = {
            left: (cur.xCoordinate - tmp) + xTmp,
            top: finalTop,
            bottom: finalBottom
          }
          console.log('this.boxPositionStyle大于的', tmp, cur, this.boxPositionStyle)
        } else {
          this.boxPositionStyle = {
            left: (cur.xCoordinate + xTmp1) + xTmp,
            top: finalTop,
            bottom: finalBottom
          }
          console.log('this.boxPositionStyle小于的', this.boxPositionStyle, cur)
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import "../../assets/less/color";

  .dote-map {
    .video-wrap {
      position: fixed !important;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 9999 !important;
    }

    h2 {
      color: @lightBlue;
      font-weight: bold;
      padding-top: 10px;
    }

    .pointCanvas{
      position: absolute;
      left: 0;
      z-index: 1;
    }

    .point {
      position: relative;
      width: 1411px;
      height: 730px;
      /*overflow: hidden;*/
      /*background: url("../../assets/images/shitang/default-bg.png") no-repeat 0 0;*/
      background-size: 100% 100% !important;
      .shidu, .pm25, .ozone {
        position: absolute;
        left: 132px;
        top: 61px;
        width: 111px;
        height: 91px;
        background: url("../../assets/images/shitang/shidu.png");
        background-size: cover;
        animation: pop 2s linear infinite;
        cursor: pointer;
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
        align-items: center;
        /*弹跳动画*/
        @keyframes pop {
          0% {
            /*margin-top: 0;*/
            transform: translateY(0)
          }
          60% {
            /*margin-top: -7px;*/
            transform: translateY(-7px)
          }
          100% {
            /*margin-top: 0;*/
            transform: translateY(0)
          }
        }

        > h3 {
          padding: 13px 0 3px 0;
          font-size: 17px;
          font-weight: bold;
          color: #fff;
        }

        > p {
          color: #f6ff00;
          font-size: 14px;
          line-height: 15px;
          > span {
            display: inline-block;
            margin-left: 3px;
            color: #fff;
          }
        }
      }
      .pm25 {
        background: url("../../assets/images/shitang/pm25.png");
        background-size: cover;
      }
      .ozone {
        background: url("../../assets/images/shitang/ozone.png");
        background-size: cover;
      }
      .common-span {
        display: none;
        position: absolute;
        bottom: -22px;
        right: -10px;
        border-radius: 4px;
        border: 1px solid #fff;
        color: #fff;
        background-color: #04843d !important;
        padding: 0 5px;
        font-size: 14px;
        max-width: 500px;
        white-space: nowrap;
        /*z-index: 9999;*/
      }

      .common-span1 {
        bottom: -58px !important;
        right: -40px !important;
      }

      .camera-pos {
        position: absolute;
      }

      .shidu:hover .common-span, .bx:hover .common-span, .camera-pos:hover .common-span {
        display: block;
      }

      /*旋转动画*/
      @keyframes show {
        0% {
          opacity: 0;
        }
        60% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }

      .bx {
        position: absolute;
        left: 553px;
        top: 180px;
        width: 30px;
        z-index: 2;
        cursor: pointer;

        img {
          width: 30px;
          vertical-align: middle;
        }
      }

      .wave-bar {
        > .no-data {
          color: #fff;
          margin-top: 75px;
          font-size: 22px;
        }
      }

      > li {
        > input {
          display: none;

          & + label {
            position: absolute;
            display: block;
            cursor: pointer;
            z-index: 3;
            height: 35px;
            width: 27px;
            background-size: 27px 35px;
            /*transform: translate(-50%, 0);*/

            img {
              height: 35px;
              width: 27px;
            }
          }
        }

        .c010101 {
          background: url("../../../static/camera/0101.png");
        }
      }
    }

    .floor {
      position: absolute;
      right: -15px;
      top: 30%;
      transform: translateY(-50%);
    }

    .grayc {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
      filter: gray;
    }

    .cusp {
      cursor: default !important;
    }

    .gl {
      display: flex;
      color: #00d6ff;
      margin-bottom: 5px;

      &-left {
        margin-right: 25px;
      }

      &-left, &-right {
        font-size: 14px;

        span {
          color: #13ff00;
          padding-left: 5px;
        }
      }
    }

    .gls {
      display: flex;
      color: #00d6ff;
      margin-bottom: 5px;
      flex-wrap: wrap;

      &-left {
        padding-right: 25px;
        width: 50%;
      }

      &-left, &-right {
        font-size: 14px;

        span {
          color: #13ff00;
          padding-left: 5px;
        }
      }
    }

    .wave-class {
      flex: 1;
      padding-right: 20px;
    }

    ul.open-his {
      width: 300px;
      background: #012747;

      .his-title {
        font-size: 15px;
        color: @lightBlue;
        text-align: center;
        padding: 5px;
      }

      .li {
        margin-bottom: 5px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;

        &-left {
          font-size: 13px;
          color: #00d6ff;
        }

        &-right {
          color: #0aaade;
          font-size: 12px;
          text-align: right;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
      }

      /*分页样式*/

      .el-pagination {
        text-align: center;
        margin-bottom: 6px;
      }

      .el-pagination.is-background .el-pager li {
        background-color: inherit;
        color: #0aaade;
        margin: 0;
        font-size: 14px;
        font-weight: normal;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
        background: inherit;
        color: #0aaade;
        margin: 0;
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #004270 !important;
        color: #00ffff;
      }
    }

    ul.open-his-0602 {
      width: 400px;
      background: #012747;

      .his-title {
        font-size: 15px;
        color: @lightBlue;
        text-align: center;
        padding: 5px;
      }

      .li {
        margin-bottom: 5px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;

        &-left {
          font-size: 13px;
          color: #00d6ff;
        }

        &-right {
          color: #0aaade;
          font-size: 12px;
          text-align: right;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
      }

      /*分页样式*/

      .el-pagination {
        text-align: center;
        margin-bottom: 6px;
      }

      .el-pagination.is-background .el-pager li {
        background-color: inherit;
        color: #0aaade;
        margin: 0;
        font-size: 14px;
        font-weight: normal;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev {
        background: inherit;
        color: #0aaade;
        margin: 0;
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #004270 !important;
        color: #00ffff;
      }
    }

    .dote-scroll {
      max-height: 480px;
      overflow-y: auto;

      .el-form-item__label {
        color: #00f0ff;
      }

      .el-table__row {
        color: #00f0ff;
        font-size: 15px;
      }

      .el-table__row td:first-child {
        color: #0aaade;
        font-size: 15px;
      }

      .el-table {
        background-color: inherit;
        color: #ffffffcc;
      }

      .el-table thead tr th {
        background-color: #021b32;
        color: #1482a6;
        font-size: 15px;
      }

      .el-table th, .el-table tr {
        background-color: rgba(0, 32, 52, .9);
      }

      .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #032a48;
      }

      .el-table th {
        padding: 14px 0;
      }

      .el-table td {
        padding: 7px 0;
      }

      .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #04385f;
      }

      .el-table--border:after, .el-table--group:after, .el-table:before {
        background-color: #ebeef500;
      }

      .moth-table {
        color: #ffffffe8;
        font-size: 14px;

        &-tr {
          display: flex;
          align-items: center;
          align-content: center;
          border: 1px solid #064472;
          background-color: #032a48;
          margin-top: 5px;
          margin-bottom: 10px;
        }

        &-td {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          flex: 6;

          &-son {
            display: flex;
            justify-content: space-between;
            width: 33.3%;
            border: 1px solid #064472;
            border-bottom: 0;
            border-right: 0;
            padding: 10px;

            .son-item {
              text-align: center;
              padding: 5px;
              color: #0aaade;
            }

            .son-item:last-child {
              color: #00f0ff;
              font-weight: bold;
            }
          }
        }

        &-td:first-child {
          font-size: 18px;
          width: 120px;
          background: #043357;
          height: 100px;
          flex: 1;
        }
      }

      &-title {
        display: flex;
        padding: 0 0 10px 0;
        color: #00f0ff;

        > div {
          margin-right: 30px;
        }
      }

      .tem-page {
        width: 100%;
        margin: 10px auto;

        .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
          color: rgba(255, 255, 255, 1);
          background: #216784;
        }

        .el-pagination {
          text-align: center;
        }

        .el-pagination.is-background .el-pager li:not(.disabled).active {
          background-color: #409eff;
          color: #fff;
        }
      }
    }

    .dote-scroll::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      background: #12507b !important;
    }

    .warning-row {
      color: #ffd400 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/doteMap.vue